import { useState, useEffect } from 'react';
import CollectMoneyService from './CollectMoneyService';
import { useSelector } from 'react-redux';

const useCollectMoney = () => {
  const [noPaidProfiles, setNoPaidProfiles] = useState([])
  const [orders, setOrders] = useState([])
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const shopName = useSelector((state) => state.shop.name);

  const getCustomersByShipDateId = async (shipDateId) => {
    setIsLoading(true);
    try {
      const response = await CollectMoneyService.getCustomersByShipDateId(shipDateId);
      console.log(response.data)
      setError(null);
      return response.data
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
    }
  };
  
  const getPersonNotPaidData = async (formData) => {
    setIsLoading(true);
    try {
      const response = await CollectMoneyService.getPersonNotPaidData(formData);
      console.log(response.data)
      setError(null);
      return response.data
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
    }
  };

  const getOldPersonNotPaidData = async (customerId) => {
    setIsLoading(true);
    try {
      const response = await CollectMoneyService.getOldPersonNotPaidData(customerId);
      setOrders(response.data)
      setError(null);
      return response.data
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
    }
  };

  const getOldPersonNotPaid = async (formData) => {
    setIsLoading(true);
    try {
      const response = await CollectMoneyService.getOldPersonNotPaid(formData);
      setError(null);
      return response.data
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
    }
  };

  const getPersonOldNotPaidDataById = async (formData) => {
    setIsLoading(true);
    try {
      const updatedFormData = { ...formData, shop: shopName }
      const response = await CollectMoneyService.getPersonOldNotPaidDataById(updatedFormData);
      setError(null);
      return response.data
    } catch (err) {
      console.log(err)
      setError(err);
      return false
    } finally {
        setIsLoading(false);
    }
  };


  return { 
    orders,
    isLoading,
    noPaidProfiles,
    getCustomersByShipDateId,
    getPersonNotPaidData,
    getPersonOldNotPaidDataById,
    getOldPersonNotPaid,
    getOldPersonNotPaidData
  };
}

export default useCollectMoney;
